import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import JoditEditor from "jodit-react";
import { Button, Select, MenuItem, Checkbox, ListItemText, InputLabel, FormControl } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { isCompany } from '../../Config/isCompany';
import NotFoundPage from '../../Pages/NotFoundPage';

const UpdatePost = () => {
    const { id } = useParams(); // ID parametresi alınır
    const [formData, setFormData] = useState({
        company_name: '',
        company_about: '',
        job_type: '',
        work_style: '',
        position_category: '',
        position_name: '',
        city: '',
        position_tags: '',
        job_description: '',
        required_qualifications: '',
        required_experience: '',
        other_comments: '',
        job_link: '',
        job_status: '',
        document_upload: null,
    });
      const [company, setCompany] = useState({});
      const [companies, setCompanies] = useState([]);
      const [selectedCompany, setselectedCompany] = useState('');

    const cities = [
        "Genel","Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya",
        "Ardahan", "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl",
        "Bitlis", "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır",
        "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun",
        "Gümüşhane", "Hakkari", "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş",
        "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırıkkale", "Kırklareli", "Kırşehir",
        "Kilis", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla",
        "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt",
        "Sinop", "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Trabzon", "Tunceli",
        "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak", "Yurt Dışı"
    ];
    const positionCategories = [
        "Araştırma Geliştirme (AR-GE)",
        "Geri Ödeme/Pazara Erişim",
        "Klinik Destek/Aplikasyon",
        "Kalite/Belgelendirme/Mevzuat",
        "Lojistik ve Tedarik Zinciri",
        "Pazarlama/Ürün Yönetimi",
        "Satış",
        "Teknik Servis",
        "Teknoloji Yönetimi",
        "Test/Kalibrasyon/Muayene",
        "Üretim",
        "Diğer"
    ];
    useEffect(() => {
        const fetchCompany = async () => {
          try {
            const response = await axios.get(
              "https://kariyer.biyomed.net/api/companies/getOne",
              { withCredentials: true }
            );
            setCompany(response.data.company);
            if (response.data.company.user_type !== "Dernek") {
              setFormData((prevState) => ({
                ...prevState,
                company_name: response.data.company.company_name,
              }));
            }
            else {
              const res = await axios.get('https://kariyer.biyomed.net/api/companies/getAll');
              setCompanies(res.data.companies);
            }
          } catch (error) {
            console.error("Error fetching company details:", error);
          }
        };
        fetchCompany()
      }, []); // `post` değiştiğinde yeniden çağırır

    // API'den veriyi çekme
    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await axios.get(`https://kariyer.biyomed.net/api/posts/getOnePost/${id}`);
                setFormData(response.data.post); // Gelen verilerle formData'yı güncelle
            } catch (error) {
                console.error("Error fetching post:", error);
            }
        };

        fetchPost(); // Veriyi çekmek için çağrılır
    }, [id]);

    // Input değişikliklerini işleyen fonksiyon
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleCityChange = (e) => {
      const selectedCities = e.target.value; // Bu, seçilen şehirlerin dizisi olacak
      
      setFormData((prevState) => ({
        ...prevState,
        city: selectedCities.length === 1 ? selectedCities[0] : selectedCities.filter(city => city.length > 0).join(', '),
        // Eğer sadece bir şehir seçildiyse, virgülle ayırmadan tek olarak kaydet, 
        // birden fazla şehir seçildiyse virgülle ayırarak kaydet
      }));
    };
    
    
    
    

    // Dosya yükleme işlemi
    // const handleFileChange = (e) => {
    //     setFormData((prevState) => ({
    //         ...prevState,
    //         document_upload: e.target.files[0], // Yüklenen dosya
    //     }));
    // };

    // Form gönderimi
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (
          !formData.city?.trim() || 
          !formData.company_name?.trim() || 
          !formData.position_category?.trim() || 
          !formData.company_about?.trim() || 
          !formData.job_type?.trim() || 
          !formData.job_description?.trim() || 
          !formData.required_experience?.trim() || 
          !formData.required_qualifications?.trim()
        ) {
          alert("Lütfen gerekli alanları doldurunuz");
          return;
        }

        const data = new FormData();
        // FormData'ya her bir alanı ekle
        for (const key in formData) {
            if (formData[key]) {
                data.append(key, formData[key]);
            }
        }
        console.log(formData);
        try {
            const response = await axios.put(
                `https://kariyer.biyomed.net/api/companies/update-post/${id}`,
                data,
                { withCredentials: true },
                {
                    headers: {
                        'Content-Type': 'multipart/form-data', // Dosya gönderirken bu header gerekli
                    },
                }
            );
            alert('İş ilanı başarıyla güncellendi!');
            window.location.href= "/myposts"
            console.log(response.data);
        } catch (error) {
            alert('Error updating job posting!');
            console.error(error);
        }
    };
    const setCompanyName = (e) => {
        setselectedCompany(e.target.value)
        if (e.target.value !== "" && e.target.value !== null) {
          console.log("girdi")
          setFormData((prevState) => ({
            ...prevState,
            company_name: e.target.value,
          }));
        } else {
          setFormData((prevState) => ({
            ...prevState,
            company_name: company.company_name,
          }));
        }
    
      }

    return (
      <>{isCompany ?         <div className="jp_adp_main_section_wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div className="jp_adp_form_heading_wrapper">
                <h2>İlan Bilgileri</h2>
              </div> {company.user_type === "Dernek" ? <div className="jp_adp_form_wrapper">
                <select
                  name="company_name"
                  value={formData.company_name}
                  onChange={(e) => { setCompanyName(e) }}
                >
                  <option disabled value="">Şirket seçiniz</option>
                  {companies.map((company, index) => (
                    <option key={index} value={company.company_name}>
                      {company.company_name}
                    </option>
                  ))}
                </select>
              </div> : <div className="jp_adp_form_wrapper">
                <input
                  type="text"
                  name="company_name"
                  value={company.company_name}
                  placeholder="Firma Adı"
                  disabled
                />
              </div>}
              <div className="jp_adp_form_wrapper">
                <select
                  type="text"
                  name="work_style"
                  value={formData.work_style}
                  onChange={handleChange}
                  placeholder="Çalışma Şekli"
                >
                  <option value="Secilmedi">Çalışma Şekli</option>
                  <option value="Uzaktan">Uzaktan</option>
                  <option value="Hibrid">Hibrid</option>
                  <option value="Is yerinde">İş Yerinde</option>
                </select>
              </div>
  
              <div className="jp_adp_form_wrapper">
                <select
                  name="position_category"
                  value={formData.position_category}
                  onChange={handleChange}
                  style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
                >
                  <option value="" disabled>Pozisyon Kategorisi Seçiniz</option>
                  {positionCategories.map((category, index) => (
                    <option key={index} value={category}>
                      {category}
                    </option>
                  ))}
                </select>
              </div>
  
              <div className="jp_adp_form_wrapper">
                <select
                  type="text"
                  name="required_experience"
                  value={formData.required_experience}
                  onChange={handleChange}
                > <option value="">Aranan Deneyim (Yıl)</option>
                  <option value="0-2">0-2 Yıl</option>
                  <option value="2-5">2-5 Yıl</option>
                  <option value="5-10">5-10 Yıl</option>
                  <option value="10+">10+ Yıl</option>
                </select>
              </div>
  
  
  
  
  
              <div className="jp_adp_form_wrapper">
                <input
                  type="text"
                  name="position_tags"
                  value={formData.position_tags}
                  onChange={handleChange}
                  placeholder="Pozisyon Etiketleri"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 bottom_line_Wrapper">
              <div className="jp_adp_form_heading_wrapper">
                <p> * doldurulmasi zorunludur</p>
              </div>
              <div className="jp_adp_form_wrapper">
                <select
                  name="job_type"
                  value={formData.job_type}
                  onChange={handleChange}
                >
                  <option disabled value="Secilmedi">İlan Türü</option>
                  <option value="Staj">Staj ilanı</option>
                  <option value="Is">İş ilanı</option>
                </select>
              </div>
  
  
              <div className="jp_adp_form_wrapper">
                  <FormControl fullWidth>
                    <InputLabel>İl Seçiniz *</InputLabel>
                    <Select
                      multiple
                      name="city"
                      value={formData.city.split(", ")}
                      onChange={handleCityChange}
                      renderValue={(selected) => selected.join(",")}
                    >
                      {cities.map((city, index) => (
                        <MenuItem key={index} value={city}>
                          <Checkbox checked={formData.city.split(", ").includes(city)} />
                          <ListItemText primary={city} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
  
              <div className="jp_adp_form_wrapper">
                <input
                  type="text"
                  name="position_name"
                  value={formData.position_name}
                  onChange={handleChange}
                  placeholder="Pozisyon Adı"
                />
              </div>
  
              <div className="jp_adp_form_wrapper">
                <input
                  type="text"
                  name="job_link"
                  value={formData.job_link}
                  onChange={handleChange}
                  placeholder="İlan Linki"
                />
              </div>
  
  
  
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              {/* <div className="jp_adp_choose_resume">
                <p>Belge Ekle</p>
                <div className="custom-input">
                  <span>
                    <i className="fa fa-upload" /> &nbsp;Belge Yükle
                  </span>
                  <input
                    type="file"
                    name="document_upload"
                    onChange={handleFileChange}
                  />
                </div>
              </div> */}
  
              <div className="jp_adp_form_wrapper">
                <label htmlFor="company_about">Firma Hakkında</label>
                <JoditEditor
                  name="company_about"
                  value={formData.company_about}
                  onBlur={(value) => setFormData({ ...formData, company_about: value })}
                  style={{ width: "100%", height: "120px", marginBottom: '50px' }}
                  placeholder="Firma Hakkında"
                />
              </div>
  
              <div className="jp_adp_form_wrapper">
                <label htmlFor="required_qualifications">Aranan Nitelikler</label>
                <JoditEditor
                  type="text"
                  value={formData.required_qualifications}
                  onBlur={(value) => setFormData({ ...formData, required_qualifications: value })}
                  placeholder="Aranan Nitelikler"
                  style={{ width: "100%", height: "120px", marginBottom: '50px' }}
                />
              </div>
  
              <div className="jp_adp_form_wrapper">
                <label htmlFor="job_description">Aranan Nitelikler</label>
                <JoditEditor
                  value={formData.job_description}
                  onBlur={(value) => setFormData({ ...formData, job_description: value })}
                  placeholder="İş tanımı"
                  style={{ width: "100%", height: "120px", marginBottom: '50px' }}
                />
              </div>
  
  
  
              <div className="jp_adp_form_wrapper">
                <label htmlFor="other_comments">Diğer Açıklamalar</label>
                <JoditEditor
                  type="text"
                  value={formData.other_comments}
                  onBlur={(value) => setFormData({ ...formData, other_comments: value })}
                  placeholder="Diğer Açıklamalar"
                />
              </div>
  
              <div className="jp_adp_form_wrapper">
                <label htmlFor="job_status">İlan Durumu (Yayımda, Kapalı)</label>
                <select
                  name="job_status"
                  value={formData.job_status}
                  onChange={handleChange}
                  placeholder="İlan Durumu"
                  required
                >
                  <option disabled value="">İlan Durumu seçiniz</option>
                  <option value="1">Yayımda</option>
                  <option value="0">Kapalı</option>
                </select>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Button
                  variant="contained"
                  color="success"
                  startIcon={<AddCircleIcon />}
                  onClick={handleSubmit}
                  sx={{
                    backgroundColor: "#007bff",
                    fontSize: "16px",
                    padding: "10px 20px",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: "bold",
                    marginTop:'20px',
                    transition: "0.3s",
                    "&:hover": {
                      backgroundColor: "#0056b3",
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  İlanı Güncelle
                </Button>
            </div>
          </div>
        </div>
      </div> : <NotFoundPage/>}</>


    );
};

export default UpdatePost;
